import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getAccountsReceivableRequest: null,
  getAccountsReceivableSuccess: ['accounts'],
  getAccountsReceivableFailure: ['error'],
  addAccountReceivableRequest: ['account', 'closeModal'],
  addAccountReceivableSuccess: ['account'],
  addAccountReceivableFailure: ['error'],
  updateAccountReceivableRequest: ['account', 'closeModal'],
  updateAccountReceivableSuccess: ['account'],
  updateAccountReceivableFailure: ['error'],
  removeAccountReceivableRequest: ['id'],
  removeAccountReceivableSuccess: ['id'],
  removeAccountReceivableFailure: ['error'],
  openModal: null,
  closeModal: null,
  setAccountReceivableActive: ['account'],
});

export const AccountsReceivableTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  accounts: [],
  accountActive: null,
  isLoading: false,
  error: null,
  openModal: false,
});

/* Reducers */

const getAccountsReceivableRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getAccountsReceivableSuccess = (state, { accounts }) =>
  state.merge({
    accounts,
    isLoading: false,
    error: null,
  });

const getAccountsReceivableFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const addAccountReceivableRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const addAccountReceivableSuccess = (state, { account }) =>
  state.merge({
    accounts: [...state.accounts, account],
    isLoading: false,
    error: null,
  });

const addAccountReceivableFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const updateAccountReceivableRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateAccountReceivableSuccess = (state, { account }) =>
  state.merge({
    accounts: state.accounts.map((item) =>
      item.id === account.id ? account : item
    ),
    isLoading: false,
    error: null,
  });

const updateAccountReceivableFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const removeAccountReceivableRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const removeAccountReceivableSuccess = (state, { id }) =>
  state.merge({
    accounts: state.accounts.filter((item) => item.id !== id),
    isLoading: false,
    error: null,
  });

const removeAccountReceivableFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const openModal = (state) =>
  state.merge({
    openModal: true,
  });

const closeModal = (state) =>
  state.merge({
    openModal: false,
    accountActive: null,
  });

const setAccountReceivableActive = (state, { account }) =>
  state.merge({
    accountActive: account,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ACCOUNTS_RECEIVABLE_REQUEST]: getAccountsReceivableRequest,
  [Types.GET_ACCOUNTS_RECEIVABLE_SUCCESS]: getAccountsReceivableSuccess,
  [Types.GET_ACCOUNTS_RECEIVABLE_FAILURE]: getAccountsReceivableFailure,
  [Types.ADD_ACCOUNT_RECEIVABLE_REQUEST]: addAccountReceivableRequest,
  [Types.ADD_ACCOUNT_RECEIVABLE_SUCCESS]: addAccountReceivableSuccess,
  [Types.ADD_ACCOUNT_RECEIVABLE_FAILURE]: addAccountReceivableFailure,
  [Types.UPDATE_ACCOUNT_RECEIVABLE_REQUEST]: updateAccountReceivableRequest,
  [Types.UPDATE_ACCOUNT_RECEIVABLE_SUCCESS]: updateAccountReceivableSuccess,
  [Types.UPDATE_ACCOUNT_RECEIVABLE_FAILURE]: updateAccountReceivableFailure,
  [Types.REMOVE_ACCOUNT_RECEIVABLE_REQUEST]: removeAccountReceivableRequest,
  [Types.REMOVE_ACCOUNT_RECEIVABLE_SUCCESS]: removeAccountReceivableSuccess,
  [Types.REMOVE_ACCOUNT_RECEIVABLE_FAILURE]: removeAccountReceivableFailure,
  [Types.OPEN_MODAL]: openModal,
  [Types.CLOSE_MODAL]: closeModal,
  [Types.SET_ACCOUNT_RECEIVABLE_ACTIVE]: setAccountReceivableActive,
});

